import { render, staticRenderFns } from "./TabBlock.vue?vue&type=template&id=471c93d8&scoped=true&"
import script from "./TabBlock.vue?vue&type=script&lang=js&"
export * from "./TabBlock.vue?vue&type=script&lang=js&"
import style0 from "./TabBlock.vue?vue&type=style&index=0&id=471c93d8&lang=scss&scoped=true&"
import style1 from "./TabBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c93d8",
  null
  
)

export default component.exports